"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xlsxTemplateProperty = exports.dataTape = exports.OtherDataTape = exports.OtherDataTapeIterable = exports.LoanProductDataTape = exports.LoanProductDataTapeIterable = exports.ServicerReportProperty = exports.ServicerReportPropertyIterable = void 0;
exports.ServicerReportPropertyIterable = [
    'reportingDate',
    'currentDate',
    'fundingRequestDate',
    'settlementDate',
    'collectionsRecycleTotalAmount',
    'collectionsPaydownTotalAmount',
    'drawRequestTotalAmount',
    'borrowingBaseReserveAmount',
    'curePaydownTotalAmount',
    'collectionsRecycleTargetFundingDate',
    'collectionsPaydownTargetFundingDate',
    'drawRequestTargetFundingDate',
    'curePaydownTargetFundingDate',
    'currentPrincipalBalance',
    'collectionsCashBalance',
    'preFundingCashBalance',
    'cashReserveAmount',
    'otherReserveCashBalance',
    'permittedInvestmentsCashBalance',
];
exports.ServicerReportProperty = {
    reportingDate: 'reportingDate',
    currentDate: 'currentDate',
    fundingRequestDate: 'fundingRequestDate',
    settlementDate: 'settlementDate',
    collectionsRecycleTotalAmount: 'collectionsRecycleTotalAmount',
    collectionsPaydownTotalAmount: 'collectionsPaydownTotalAmount',
    drawRequestTotalAmount: 'drawRequestTotalAmount',
    borrowingBaseReserveAmount: 'borrowingBaseReserveAmount',
    curePaydownTotalAmount: 'curePaydownTotalAmount',
    collectionsRecycleTargetFundingDate: 'collectionsRecycleTargetFundingDate',
    collectionsPaydownTargetFundingDate: 'collectionsPaydownTargetFundingDate',
    drawRequestTargetFundingDate: 'drawRequestTargetFundingDate',
    curePaydownTargetFundingDate: 'curePaydownTargetFundingDate',
    currentPrincipalBalance: 'currentPrincipalBalance',
    collectionsCashBalance: 'collectionsCashBalance',
    preFundingCashBalance: 'preFundingCashBalance',
    cashReserveAmount: 'cashReserveAmount',
    otherReserveCashBalance: 'otherReserveCashBalance',
    permittedInvestmentsCashBalance: 'permittedInvestmentsCashBalance',
};
exports.LoanProductDataTapeIterable = [
    'rawAssignedLoanTape',
    'rawCovenantLoanTape',
    'rawMasterLoanTape',
    'generatedAssignedLoanTape',
    'generatedCovenantLoanTape',
    'generatedMasterLoanTape',
    'responseTape',
    'extendedResponseTape',
    'newlyAssignedExtendedResponseTape',
    'repaymentTape',
];
exports.LoanProductDataTape = {
    rawAssignedLoanTape: 'rawAssignedLoanTape',
    rawCovenantLoanTape: 'rawCovenantLoanTape',
    rawMasterLoanTape: 'rawMasterLoanTape',
    generatedAssignedLoanTape: 'generatedAssignedLoanTape',
    generatedCovenantLoanTape: 'generatedCovenantLoanTape',
    generatedMasterLoanTape: 'generatedMasterLoanTape',
    responseTape: 'responseTape',
    extendedResponseTape: 'extendedResponseTape',
    newlyAssignedExtendedResponseTape: 'newlyAssignedExtendedResponseTape',
    repaymentTape: 'repaymentTape',
};
exports.OtherDataTapeIterable = ['borrowingBaseReserve'];
exports.OtherDataTape = {
    borrowingBaseReserve: 'borrowingBaseReserve',
};
exports.dataTape = {
    ...exports.LoanProductDataTape,
    ...exports.OtherDataTape,
};
exports.xlsxTemplateProperty = {
    ...exports.ServicerReportProperty,
    ...exports.LoanProductDataTape,
    ...exports.OtherDataTape,
};
//# sourceMappingURL=ReportXlsxTemplate.js.map